import React from "react";

export default function AdvancePostponeModal({
  open,
  row,
  date,
  reason,
  error,
  submitting,
  minDate,
  amountLabel,
  onDateChange,
  onReasonChange,
  onClose,
  onSubmit,
}) {
  if (!open || !row) return null;

  return (
    <div className="adv-disburse-modal-overlay" onClick={onClose}>
      <div
        className="adv-disburse-modal"
        onClick={(e) => e.stopPropagation()}
        dir="rtl"
      >
        <h3 className="adv-disburse-modal-title">تأجيل صرف السلفة</h3>
        <p className="adv-disburse-modal-subtitle">
          {row.employeeName || "الموظف"}
          {amountLabel ? ` — ${amountLabel}` : ""}
        </p>
        <p className="adv-disburse-modal-hint">
          المحاسب العام لا يمكنه إلغاء السلفة. يمكن تأجيل الصرف ليوم لاحق مع
          كتابة السبب.
        </p>

        <label className="adv-disburse-field">
          تاريخ الصرف الجديد
          <input
            type="date"
            min={minDate}
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            disabled={submitting}
            required
          />
        </label>

        <label className="adv-disburse-field">
          سبب التأجيل (إجباري)
          <textarea
            rows={3}
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            disabled={submitting}
            required
            minLength={3}
            maxLength={500}
            placeholder="اكتب سبب تأجيل الصرف"
          />
        </label>

        {error ? <p className="adv-disburse-modal-error">{error}</p> : null}

        <div className="adv-disburse-modal-actions">
          <button
            type="button"
            className="adv-disburse-btn ghost compact"
            onClick={onClose}
            disabled={submitting}
          >
            رجوع
          </button>
          <button
            type="button"
            className="adv-disburse-btn compact"
            onClick={onSubmit}
            disabled={submitting}
          >
            {submitting ? "جاري التأجيل..." : "تأكيد التأجيل"}
          </button>
        </div>
      </div>
    </div>
  );
}
